import { useEffect, useState } from "react";
import { Container, Image, Nav, Navbar, Row, Col, Badge, Button } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";

export default function NavigationBar() {
	const [navbar, setNavbar] = useState<any>();

	// window.addEventListener('scroll', () => {
	// 	if (navbar) {
	// 		if (window.scrollY > 100) {
	// 			navbar?.classList.add('scrolled');
	// 		} else {
	// 			navbar?.classList.remove('scrolled');
	// 		}
	// 	}
	// });
	// useEffect(function getNAvbar() {
	// 	setNavbar(document.getElementById('navbar'))
	// }, []);

	return (
		<>
			<Navbar
				expand="lg"
				className={`navigation-brand`}
				fixed="top"
				id="navbar"
			>
				<Container>
					<Navbar.Brand href="/home">
						<Image
							className="navigation-logo"
							src={"/images/EarsOnly_Logo_FullColour_Black.svg"}
							alt="EarsOnly logo"
						/>

					</Navbar.Brand>
					<Navbar.Toggle aria-controls="basic-navbar-nav" />
					<Navbar.Collapse id="basic-navbar-nav black">
						<Container >
							<Nav className="nav-container">
								<Row xs={1} sm={1} md={1} lg={"auto"}>
									<Col >
										<Nav.Link href="/home">Home</Nav.Link>
									</Col>
									<Col >
										<Nav.Link href="/protect">Protect</Nav.Link>
									</Col>
									<Col >
										<Nav.Link href="/redux">Redux</Nav.Link>
									</Col>
									<Col >
										<Nav.Link href="/faq">Support</Nav.Link>
									</Col>
									<Col className="book-demo">
										<Nav.Link href="/contact">Contact us</Nav.Link>
									</Col>

									<Col>
										<Nav.Link
											target="_blank"
											href="https://earsonly-portal.dopple.site"
											className="navigation-portal "
										>
											Portal
										</Nav.Link>
									</Col>
								</Row>
							</Nav>
						</Container>
					</Navbar.Collapse>
				</Container>
			</Navbar>
		</>
	);
}
